import { Inbox } from "@assets";
import { LBtn } from "@components";

export const NoUpcomingAssessments = ({ disableButtons, onClick }: NoUpcomingAssessmentsProps): JSX.Element => {
    return (
        <div className="w-80">
            <div className="box my-6">
                <div className="is-flex is-flex-direction-column is-justify-content-center is-align-items-center has-text-center">
                    <div className="title my-5">You have no upcoming assessments</div>
                    <Inbox />
                    <div className="my-5">
                        <LBtn
                            isBold
                            disabled={disableButtons}
                            toolTipText={
                                "Your account is out of assessments. More can be purchased in the \"Manage\" section of the LASSI-D™ portal."
                            }
                            onClick={onClick}
                        >
                            + Add Assessment
                        </LBtn>
                    </div>
                </div>
            </div>
        </div>
    );
};

interface NoUpcomingAssessmentsProps {
    disableButtons?: boolean;
    onClick: () => void;
}
